const copyToClipBoard = async ({ link, onSuccess, onError }: any) => {
  await navigator.clipboard
    .writeText(link)
    .then((res) => {
      onSuccess();
    })
    .catch(() => {
      onError();
    });
};

export { copyToClipBoard };